import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="relative flex min-h-[70vh] flex-col items-center justify-center overflow-hidden px-4 py-24 text-center">
      <span className="pointer-events-none absolute select-none font-display text-[26vw] font-black leading-none text-background-100">
        404
      </span>
      <div className="relative z-10">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
          <i className="ri-emotion-sad-line" />
          走错瓜田啦
        </span>
        <h1 className="mt-4 font-display text-3xl font-black text-foreground-950 md:text-4xl">
          这个页面溜到别处吃瓜去了
        </h1>
        <p className="mx-auto mt-3 max-w-md text-foreground-600">
          你访问的地址不存在或已更新，回首页看看本期瓜单与吃瓜指南吧。
        </p>
        <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 cursor-pointer"
          >
            <i className="ri-home-4-line" />
            回到首页
          </Link>
          <Link
            to="/#gua"
            className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 hover:border-primary-300 hover:text-primary-700 cursor-pointer"
          >
            <i className="ri-fire-line" />
            去看本期瓜单
          </Link>
        </div>
      </div>
    </section>
  );
}